import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs, { Dayjs } from "dayjs";
import { useField } from "formik";
import { getDateRange } from "../../helpers/date-time-helper";
import { formatMessage } from "../../translations/format-message";
import { useStore } from "../../contexts/store-provider";
import { observer } from "mobx-react";
import "dayjs/locale/en";
import "dayjs/locale/ja";
import { IsItInHoliday, IsStoreClosedByDate } from "../../constants/constants";
import moment from "moment";

const FormikDateFieldMUI = (props: any) => {
  const {preferencesStore} = useStore();
  const {
    disabled,
    min,
    max,
    label,
    disableFuture,
    disablePastDate,
    publishDateRange,
    isScheduleCheck = false,
    isWeekdayScheduleCheck = false,
    getClosedDays,
    reservationSettingDetail,
    localStateUpdate
  } = props;
  const [field, meta, helpers] = useField(props);
  const { touched, error } = meta;

  const shouldDisableDate = (date: Dayjs) => {
    const day = date.day(); // 0 (Sun) to 6 (Sat)
    const dateStr = date.format("YYYY-MM-DD");
    let isStoreClose = IsStoreClosedByDate(
      reservationSettingDetail,
      moment(date.toString()).format("YYYY-MM-DD"),
    );
    const publishedDates = getDateRange(
      publishDateRange.startDate,
      publishDateRange.endDate,
    );

    if (
      getClosedDays &&
      IsItInHoliday(dateStr) &&
      getClosedDays.map((day: any) => day.WeekDays).includes(day)
    ) {
      return (
        (publishedDates && publishedDates.includes(dateStr)) || isStoreClose
      );
    } else {
      return (
        (getClosedDays &&
          getClosedDays.map((day: any) => day.WeekDays).includes(day)) ||
        (publishedDates && publishedDates.includes(dateStr)) ||
        isStoreClose
      );
    }
  };

  const shouldDisableClosedDates = (date: Dayjs) => {
    let isStoreClose = IsStoreClosedByDate(
      reservationSettingDetail,
      moment(date.toString()).format("YYYY-MM-DD"),
    );
    const day = date.day(); // 0 (Sun) to 6 (Sat)
    let isClosed = getClosedDays.map((day: any) => day.WeekDays).includes(day);
    const dateStr = date.format("YYYY-MM-DD");
    if (getClosedDays) {
      if (IsItInHoliday(dateStr) && isClosed) {
        return false;
      }
    } else {
      return (
        (getClosedDays &&
          getClosedDays.map((day: any) => day.WeekDays).includes(day)) ||
        isStoreClose
      );
    }
  };
  return (
    <>
      <LocalizationProvider 
        dateAdapter={AdapterDayjs}
        adapterLocale={preferencesStore.getLanguage === "en" ? "en" : "ja"}>
        <Stack spacing={3}>
          <DesktopDatePicker
            label={label}
            views={["year", "month", "day"]}
            inputFormat="YYYY/MM/DD"
            value={field.value ? dayjs(field.value) : null}
            className="datepicker-control"
            onChange={(newValue: any) => {
              helpers.setValue(
                newValue ? dayjs(newValue).format("YYYY-MM-DD") : ""
              );
              if(localStateUpdate)
                localStateUpdate();
            }}
            disableFuture={disableFuture}
            disablePast={disablePastDate}
            disabled={disabled}
            minDate={min ? dayjs(min) : undefined}
            maxDate={max ? dayjs(max) : undefined}
            renderInput={(params: any) => (
              <TextField {...params} readOnly={true} />
            )}
            shouldDisableDate={
              isScheduleCheck
                ? shouldDisableDate
                : isWeekdayScheduleCheck
                ? shouldDisableClosedDates
                : undefined
            }
            PopperProps={{
              modifiers: [
                {
                  name: 'flip',
                  enabled: true,
                  options: {
                    fallbackPlacements: ['top-start', 'bottom-start'],
                  },
                },
                {
                  name: 'preventOverflow',
                  enabled: true,
                  options: {
                    altAxis: true,
                    tether: true,
                  },
                },
              ],
            }}
          />
        </Stack>
      </LocalizationProvider>
      {touched && error && (
        <span data-testid="testError" className="text-danger errorMessage">
          {formatMessage(error)}
        </span>
      )}
    </>
  );
}

export default observer(FormikDateFieldMUI);
